<template>
	<div class="policy">
		<basic-container>
			<template>
				<el-row :span="24">
					<el-col :md="24" :sm="24" :xs="24">
						<avue-crud
							ref="crud"
							:data="tableData"
							:option="tableOption"
							:page.sync="page"
							:summary-method="summaryMethod"
							:table-loading="tableLoading"
							@on-load="toList"
							@search-change="searchChange"
							@search-reset="searchReset"
							@refresh-change="refreshChange"
							@size-change="sizeChange"
							@current-change="currentChange"
							@row-update="handleUpdate"
							@row-save="handleSave"
							@row-del="rowDel">
							<template slot="menuLeft" slot-scope="{size}">
								<el-radio-group v-model="searchForm.status" @change="statusChange">
									<el-radio-button
										v-for="button in statusButtons"
										:key="button.label"
										:size="size"
										:label="button.label"
										v-show="!button.condition || button.condition()">
										{{ button.text }}
									</el-radio-button>
								</el-radio-group>
								<el-button
									v-if="isShowMoreInsured"
									icon="el-icon-plus"
									style="margin-left: 30px"
									type="primary"
									@click="onToMoreInsured('editMoreInsured')">
									批量更改被保险人
								</el-button>
								<el-button
									v-if="isShowMoreInsured"
									icon="el-icon-plus"
									style="margin-left: 20px"
									type="primary"
									@click="onToMoreInsured('addMoreInsured')">
									批量增加被保险人
								</el-button>
							</template>
							<template #menu="{row}">
								<template v-if="searchForm.status == -2">
									<div class="u-row-center" style="width: 100%">
										<el-button icon="el-icon-view" type="text" @click="handleViewSurrender(row)">查看</el-button>
										<el-button icon="el-icon-view" type="text" @click="handleView(row)">保单详情</el-button>
										<!-- <el-button
											v-if="row.btn && row.btn.cancel"
											:loading="isShowLoading"
											icon="el-icon-close"
											type="text"
											@click="handleCancel(row)">
											取消
										</el-button> -->
										<el-button
											v-if="row.btn && row.btn.submitMaterial"
											icon="el-icon-upload"
											type="text"
											@click="handleSubmitMaterials(row)">
											提交材料
										</el-button>
										<el-button
											v-if="row.btn && row.btn.addMaterial"
											icon="el-icon-upload"
											type="text"
											@click="handleSupplementMaterials(row)">
											补传材料
										</el-button>
										<el-button
											v-if="row.btn && row.btn.addExpressNo"
											icon="el-icon-upload"
											type="text"
											@click="handleSubmitExpressNo(row)">
											上传快递单号
										</el-button>
										<el-button
											v-if="row.btn && row.btn.showEndorse"
											icon="el-icon-view"
											type="text"
											@click="handleViewSurrenderDocs(row)">
											查看电子批单
										</el-button>
									</div>
								</template>
								<template v-else-if="searchForm.status == 999">
									<div style="width: 100%">
										<el-button :loading="isShowLoading" icon="el-icon-edit" type="text" @click="handleEditStaging(row)">
											编辑
										</el-button>
										<el-button
											:disabled="isStagingDeleting"
											icon="el-icon-delete"
											type="text"
											@click="handleDeleteStaging(row)">
											删除
										</el-button>
									</div>
								</template>
								<template v-else>
									<div style="width: 180px">
										<div
											v-if="
												searchForm.status == 0 &&
												(row.redpackStatus === 'RECEIVED' ||
													row.redpackStatus === 'WAIT_RECEIVE' ||
													row.redpackStatus === 'WAIT_CONFIRM')
											"
											class="u-flex u-row-center u-col-center"
											style="cursor: pointer"
											@click="onGetRedPacketCode(row)">
											<svg aria-hidden="true" class="icon-test">
												<use xlink:href="#icon-hongbao"></use>
											</svg>
											<span
												v-if="row.redpackStatus === 'WAIT_RECEIVE'"
												class="u-font-weight-bold"
												style="color: #409eff">
												领取红包
											</span>
											<span
												v-else-if="row.redpackStatus === 'RECEIVED'"
												class="u-font-weight-bold"
												style="color: #b0b0b0">
												已领取红包
											</span>
											<span v-else class="u-font-weight-bold">刷新红包</span>
										</div>
										<el-button icon="el-icon-view" type="text" @click="handleView(row)">查看</el-button>
										<pay-btn
											v-if="searchForm.status == 1"
											:pay-btn-data-temp="getOrderData(row)"
											@onPayOffLineSuccess="onPayOffLineSuccess"
											@onToOfflinePay="onToOfflinePay"></pay-btn>
										<!--                    <el-button v-if="searchForm.status == 0 && row.allowShort && !row.shortPolicId" icon="el-icon-plus" type="text" @click="onAddInsured(row,'addOtherInsured')">购买补充方案-->
										<!--                    </el-button>-->
										<el-button
											v-if="searchForm.status == 0 && row.allowSpecEndorse"
											:loading="isShowLoading"
											icon="el-icon-plus"
											type="text"
											@click="onAddInsured(row, EnumInsureUrlType.addInsured)">
											新增被保险人
										</el-button>
										<el-button
											v-if="searchForm.status == 0 && row.allowCoinsuredEndorse"
											:loading="isShowLoading"
											icon="el-icon-edit"
											type="text"
											@click="onAddInsured(row, EnumInsureUrlType.editSingleInsured)">
											更改被保险人
										</el-button>

										<div v-if="(searchForm.status == 2 || searchForm.status == 3) && row.repurchase && row.renewFlag">
											<div
												class="u-flex u-row-center u-col-center"
												style="cursor: pointer"
												@click="judgeHandleRe(row, 2)">
												<svg aria-hidden="true" class="icon-test">
													<use xlink:href="#icon-hongbao"></use>
												</svg>
												<span class="u-font-weight-bold" style="color: #409eff">出单有惊喜</span>
											</div>
											<el-button
												:loading="isShowLoading"
												icon="el-icon-edit"
												type="text"
												@click="judgeHandleRe(row, 2)">
												续保
											</el-button>
											<el-button
												:loading="isShowLoading"
												icon="el-icon-edit"
												type="text"
												@click="judgeHandleRe(row, 3)">
												计划书
											</el-button>
										</div>
										<div
											v-else-if="
												(searchForm.status == 5 ||
													searchForm.status == 0 ||
													searchForm.status == 2 ||
													searchForm.status == 3) &&
												row.renewFlag
											">
											<el-button
												:loading="isShowLoading"
												icon="el-icon-edit"
												type="text"
												@click="judgeHandleRe(row, 2)">
												续保
											</el-button>
											<el-button
												v-if="!isJiaDian(row.insureType)"
												:loading="isShowLoading"
												icon="el-icon-edit"
												type="text"
												@click="judgeHandleRe(row, 3)">
												计划书
											</el-button>
										</div>
										<div v-else class="u-flex u-row-center">
											<el-button
												v-if="
													!isRenBao(row.insureType) &&
													(searchForm.status == 1 ||
														searchForm.status == -1 ||
														searchForm.status == 8 ||
														(searchForm.status == 100 && row.status == 102) ||
														(searchForm.status == 3 && row.status == 5))
												"
												:loading="isShowLoading"
												icon="el-icon-edit"
												type="text"
												@click="judgeHandleRe(row, 1)">
												重新提交
											</el-button>
											<el-button
												v-if="isRenBao(row.insureType) && searchForm.status == 1"
												:loading="isShowLoading"
												icon="el-icon-close"
												type="text"
												@click="onCancelPolicy(row)">
												取消
											</el-button>
										</div>

										<div>
											<el-button
												v-if="searchForm.status == 1 && isDownloadPayFile(row.insureType)"
												:loading="isShowLoading"
												icon="el-icon-download"
												type="text"
												@click="onDownloadPayFile(row)">
												下载缴费通知书
											</el-button>
										</div>
									</div>
								</template>
							</template>
						</avue-crud>
					</el-col>
				</el-row>
			</template>
			<el-dialog :visible.sync="dialogExpressVisible" center class="avue-dialog avue-dialog--top" title="上传快递单号">
				<avue-form v-model="formExpress" :option="optionExpress" @submit="handleTrackingNumberUpload"></avue-form>
			</el-dialog>

			<product-choice
				:isShowProductChoiceTemp="isShowProductChoice"
				:product-list="productList"
				@onClickClose="onClickClose"
				@onClickInsure="onClickInsure"></product-choice>

			<insure-notices ref="refInsureNotices" @onToInsure="onAgreeInsure" @onToSure="onAgreeInsure"></insure-notices>

			<PayOffLineDialog ref="refPayDialog"></PayOffLineDialog>

			<show-pdf-dialog ref="refPdf"></show-pdf-dialog>

			<!--小程序二维码-->
			<el-dialog :visible.sync="isShowQrCode" center title="微信扫一扫，有惊喜降临" width="30%">
				<div class="u-flex u-row-center" style="padding: 0 20px">
					<img :src="'data:image/png;base64,' + qrCodeUrl" alt="" />
				</div>
				<div class="u-flex u-row-center" style="margin-top: 30px">
					<el-button :loading="isShowLoading" icon="el-icon-refresh" type="primary" @click="onRefreshCode">
						刷新小程序码
					</el-button>
				</div>
			</el-dialog>
		</basic-container>
	</div>
</template>

<script>
import {
	delStaging,
	downloadPolicyFeeDetail,
	fetchMyPolicyList,
	getInsuredCheckSpecDate,
	getPayResultCheck,
	getPreCheckPost,
	getRedpackDetailSync,
	getStagingList,
	onCancelPolicy,
	proxyProcess,
	proxyProcessMy,
	getRenewAndRedoOrder,
} from '@/api/insurance/policy'
import {optionExpress, policyListOption, policyProcessOption, stagingListOption} from '@/const/crud/insurance/policy'
import pdf from 'vue-pdf'
import 'viewerjs/dist/viewer.css'
import {component as Viewer} from 'v-viewer'
import PayOffLineDialog from '@/views/insurance/product/common/payOffLineDialog'
import PayBtn from '@/components/insurance/payBtn'
import ProductChoice from '@/components/insurance/productChoice'
import {toYYYYmmddFullDate} from '@/util/date'
import {setStore} from '@/util/store'
import rrlog from '@meibao/traceback-record'
import {getProductList} from '@/api/insurance/product'
import {openPdfUrl} from '@/util/util'
import {InsureNotices} from 'meibao-insure'
import {getPageId} from 'meibao-insure/src/util/commonUtils'
import {getCenterProductId} from '@/views/insuranceCenter/api/insureApiNew'

import '@/../public/css/iconfont'
import {isDownloadPayFile, isJiaDian, isRenBao} from 'meibao-insure/src/util/productUtil'
import {toInsureCenter} from '@/util/insureUtils'
import ShowPdfDialog from '@/components/insurance/showPdfDialog.vue'
import {EnumInsureUrlType} from '@/const/enum'
import {isMainChannelAndInner} from '@/util/channelUtil'
import sensorsUtils from '@/util/sensorsUtils'

export default {
	components: {
		ShowPdfDialog,
		ProductChoice,
		PayBtn,
		PayOffLineDialog,
		pdf,
		Viewer,
		InsureNotices,
	},
	name: 'policy',
	data() {
		return {
			searchForm: {
				status: 0,
				pids: [],
			},
			statusButtons: [
				{label: '0', text: '投保成功'},
				{label: '1', text: '待支付'},
				{label: '2', text: '待续保'},
				{label: '3', text: '已到期'},
				{label: '-1', text: '支付失效'},
				{label: '8', text: '已取消', condition: () => this.envConfig.isBxIe()},
				{label: '-2', text: '处理中'},
				{label: '100', text: '核保'},
				{label: '999', text: '暂存'},
			],
			tableData: [],
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条
				pageSizes: [20, 50, 100, 500],
			},
			tableLoading: false,
			tableOption: policyListOption,
			optionExpress: optionExpress,
			//  快递单号上传
			dialogExpressVisible: false,
			formExpress: {
				company: '',
				trackingNumber: '',
			},
			dataCourierCompany: [],
			policySelected: null,
			pdfDialogVisible: false,
			pdfList: {},
			isStagingDeleting: false,

			rowSelected: {},
			isShowLoading: false,
			isShowMoreInsured: false,
			productList: [],
			allProductList: [],
			isShowProductChoice: false,
			rrlogEventId: null,
			isDownLoading: false,
			//小程序码
			isShowQrCode: false,
			qrCodeOption: {
				height: 100,
				width: 100,
			},
			qrCodeUrl: '',
			currentOrderId: '',
			//当前跳转不同界面类型
			currentType: '',
		}
	},
	computed: {
		EnumInsureUrlType() {
			return EnumInsureUrlType
		},
	},
	activated() {
		console.log('保单列表----created')
		this.$Bus.$on('onNoticesHint', this.onNoticesHint)
	},
	deactivated() {
		console.log('保单列表----beforeDestroy')
		this.$Bus.$off('onNoticesHint', this.onNoticesHint)
	},
	created() {
		let {status = 0} = this.$route.query
		if (status !== 0) {
			this.searchForm.status = status
		}
		this.init()
	},
	beforeDestroy() {},
	methods: {
		isRenBao,
		isJiaDian,
		isDownloadPayFile,
		summaryMethod({columns, data}) {
			let sums = []
			sums.length = columns.length

			columns.forEach((column, index) => {
				let prop = column.property
				if ('menu' == prop) {
					let values = this.tableData.map((item) => Number(item['totalMoney'] || 0))
					let sumValue =
						values && values.length > 0
							? values.reduce((a, b) => {
									return (a || 0) + (b || 0)
							  })
							: 0
					sums[index] = `合计总保费：${parseInt(sumValue)}元`
				} else {
					sums[index] = '-'
				}
			})
			return sums
		},
		init() {
			if (this.envConfig.isBxIe()) {
				//请求数据，判断批量更改，新增被保险人按钮
				getInsuredCheckSpecDate().then(({data: {data = false}}) => {
					this.isShowMoreInsured = data
				})
			}
			//获取产品
			getProductList()
				.then((response) => {
					let {code = -1, data} = response.data
					if (code === 0) {
						this.allProductList = data || []
					}
				})
				.catch(() => {})
				.finally(() => {})
		},
		handleDeleteStaging(row) {
			this.$confirm('暂存保单删除后将无法恢复, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.isStagingDeleting = true
					delStaging(row.id)
						.then((response) => {
							this.tableData.forEach((item, index) => {
								if (item.id == row.id) {
									this.$delete(this.tableData, index)
								}
							})
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
						})
						.catch(() => {})
						.finally(() => {
							this.isStagingDeleting = false
						})
				})
				.catch(() => {})
		},
		async handleEditStaging(rowData) {
			this.rowSelected = rowData
			let {id = '', productId = '', fields: {fields = null} = {}} = this.rowSelected
			this.rrlogEventId = rrlog.capture(
				`编辑暂存`,
				{
					stagingId: id,
				},
				{
					sign: true,
				},
			)
			this.act = 'staging'
			//暂存处理数据！
			if (!this.validatenull(fields)) {
				let {productId: productId1 = '', sourceProductId = ''} = fields
				this.rowSelected.productId = productId1
				this.rowSelected.sourceProductId = sourceProductId
			}
			if (this.validatenull(this.rowSelected.sourceProductId)) {
				//没有找到存储的数据！！ 老单子，通过接口处理
				let resultData = await getCenterProductId(productId)
				if (!this.validatenull(resultData)) {
					let {productId: productId2, sourceProductId = ''} = resultData
					this.rowSelected.productId = productId2
					this.rowSelected.sourceProductId = sourceProductId
				} else {
					this.rowSelected.sourceProductId = productId
					this.rowSelected.productId = ''
				}
			}
			//处理弹窗
			this.onDealDialog()

			//加埋点
			this.onAddTrackEvent('暂存提交', id)
		},
		handleView(row) {
			let {orderId = ''} = row
			if (!orderId) {
				this.$alert('当前数据为批量操作，无详情数据！', '提示').then(() => {})
				return
			}
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/details/${orderId}`,
				}),
			})

			//加埋点
			this.onAddTrackEvent('查看详情', orderId)
		},
		handleViewSurrender(row) {
			let {id = ''} = row
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/surrender/detail/${id}`,
				}),
			})

			//加埋点
			this.onAddTrackEvent('查看退保详情', id)
		},
		handleSubmitMaterials({id, applyType}) {
			if (applyType !== 403 && applyType !== 402 && applyType !== 412 && applyType !== 413) {
				//退保提交材料
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/policy/surrender/apply/${id}`,
					}),
				})
			} else {
				//共同保险人
				this.handleSupplementMaterials({id})
			}

			//加埋点
			this.onAddTrackEvent('查看退保提交材料', id)
		},
		handleSupplementMaterials({id}) {
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/surrender/supplement/${id}`,
				}),
			})
		},
		handleSubmitExpressNo(row) {
			proxyProcessMy(
				Object.assign({
					proxyFlag: 'apply_express',
				}),
			)
				.then((response) => {
					let data = response.data.data
					this.dataCourierCompany.length = 0
					if (!this.validatenull(data)) {
						data.forEach((item, index) => {
							this.dataCourierCompany.push({
								value: item.value,
								label: item.name,
							})
						})
						this.optionExpress.column[0].dicData = this.dataCourierCompany
					}
					this.policySelected = row
					this.dialogExpressVisible = true
				})
				.catch(() => {})
				.finally(() => {})
		},
		handleTrackingNumberUpload(form, done) {
			proxyProcessMy(
				Object.assign({
					proxyFlag: 'edit_express',
					applyId: this.policySelected.id,
					data: {
						expressCompany: this.formExpress.company,
						expressNo: this.formExpress.trackingNumber,
					},
				}),
			)
				.then((response) => {
					this.$message({
						message: '快递单号 上传成功',
						type: 'success',
					})
				})
				.catch(() => {})
				.finally(() => {
					done()
					this.dialogExpressVisible = false
				})
		},
		handleViewSurrenderDocs(row) {
			this.$refs.refPdf.handleViewSurrenderDocs(row)
		},
		//续保，重新提交 1,重新提交  2，续保 3 计划书
		async judgeHandleRe(row, type) {
			//操作类型
			try {
				this.act = type === 1 ? 'resubmit' : type === 2 ? 'renew' : 'plan'
				let actText = type === 1 ? '重新提交' : type === 2 ? '续保' : '计划书'
				let {orderId = ''} = row

				//加埋点
				this.onAddTrackEvent(actText, orderId)

				if (orderId === '') {
					this.$alert('暂时无法进行重新录入操作，请重新录入保单！', '提示').then(() => {})
					return
				}
				this.isShowLoading = true
				//判断不同接口
				let tempOrder = await getRenewAndRedoOrder({orderId, type: type === 2 ? 'RENEW' : 'REDO'})
				let {data: {products = [], popup = false} = {}} = tempOrder.data
				if (products.length <= 0) {
					this.$alert(`该保单不支持${actText},请重新选择投保产品!`, '提示', {
						confirmButtonText: '确定',
					}).then(() => {})
					return
				}
				if (!popup) {
					//不弹窗，默认第一个，直接处理
					//直接保存数据，进入投保信息
					this.rowSelected = this.deepClone(Object.assign(row, products[0]))
					this.rrlogEventId = rrlog.capture(
						`${actText}`,
						{
							orderId: orderId,
						},
						{
							sign: true,
						},
					)
					//处理弹窗
					this.onDealDialog()
					return
				}
				//剩下的都弹窗，自主选择
				this.productList = products
				this.rowSelected = this.deepClone(row)
				this.rrlogEventId = rrlog.capture(
					`${actText}`,
					{
						orderId: orderId,
					},
					{
						sign: true,
					},
				)
				this.isShowProductChoice = true
			} catch (error) {
			} finally {
				this.isShowLoading = false
			}
		},
		onClickInsure(tempData) {
			this.isShowProductChoice = false
			Object.assign(this.rowSelected, tempData)
			//处理弹窗
			this.onDealDialog()
		},
		onClickClose() {
			this.isShowProductChoice = false
		},
		onNoticesHint(query = null) {
			//如果是通知进入的则直接处理
			if (query) {
				let {status = '0'} = query
				this.searchForm.status = status
				//刷新界面
				this.toList()
			}
		},
		toList(page = {}, params = {}) {
			switch (this.searchForm.status) {
				case '-2':
					this.getProcess(this.page, params)
					break
				case '999':
					this.getStagingList(this.page, params)
					break
				default:
					this.getList(this.page, params)
					break
			}
		},
		async getList(page = {}, params = {}) {
			try {
				this.tableLoading = true
				let searchData = this.deepClone(this.searchForm)
				//如果是激活有礼，则处理数据 101
				if (searchData.status == 101) {
					searchData.status = 3
					searchData.orderType = 'expired'
				} else {
					searchData.orderType = ''
				}
				//家电！！！！！
				// searchData.pids = getJiaDianID()
				//处理数据
				let {currentPage: pageNo, pageSize} = page
				//排序
				//投保传1  续保传2
				searchData.sortType = searchData.status == 2 ? 2 : 1
				let policyList = (await fetchMyPolicyList(Object.assign({pageNo, pageSize}, params, searchData))) || {}
				let {data = {}, code = -1} = policyList.data || {}
				if (code === 0) {
					this.tableOption = policyListOption
					let {status = '-11'} = this.searchForm
					//隐藏保单号
					this.tableOption.column.forEach((itemData) => {
						if (itemData.prop === 'policyNo') {
							itemData.hide = status == 1 || status == -1 || status == 8 || status == 100
						}
					})
					let {total = 0, records = []} = data
					this.page.total = total
					this.tableData = []
					if (records.length > 0) {
						let tempOrderIds = []
						//处理数据
						records.forEach((itemData) => {
							//处理金额
							let {totalMoney, status: statusNei, startDate, orderId = ''} = itemData
							if (totalMoney > 0) {
								itemData.totalMoney = totalMoney / 100
							}
							//处理状态
							if (statusNei == 3 && new Date(startDate).getTime() - Date.now() > 0) {
								itemData.status = 3.5
							}
							tempOrderIds.push(orderId)
						})
						let checkResult = {}
						if (status == '0') {
							//投保成功
							checkResult = (await getPayResultCheck({orderIds: tempOrderIds})) || {}
						} else if (status === '2' || status === '3') {
							//获取红包接口
							//红包功能增加字段：redpackType 红包类型，repurchase复购，expired脱保，renewal续保
							//renewal续保 只有主渠道和内勤可见
							if (isMainChannelAndInner) {
								checkResult = (await getPreCheckPost({orderIds: tempOrderIds, redpackType: 'renewal'})) || {}
							}
						}
						if (!this.validatenull(checkResult)) {
							let {code = -1, data = []} = checkResult.data
							if (code === 0 && data.length > 0) {
								data.forEach((itemData) => {
									let {orderId = ''} = itemData
									let tempIndex = records.findIndex((itemData1) => itemData1.orderId === orderId)
									if (tempIndex > -1) {
										records[tempIndex] = Object.assign(records[tempIndex], itemData)
									}
								})
							}
						}
						this.tableData = records
					}
				}
			} catch (e) {
				this.$message.error(e)
			} finally {
				this.tableLoading = false
			}
		},
		getStagingList(page) {
			this.tableLoading = true
			getStagingList({
				pageNo: page.currentPage,
				pageSize: page.pageSize,
			})
				.then((response) => {
					this.page.total = response.data.data.length
					this.tableOption = stagingListOption
					response.data.data.forEach((itemData) => {
						let {effectiveDate = '', expiryDate = '', updatedAt = ''} = itemData
						if (effectiveDate !== '' && !effectiveDate.includes('-')) {
							itemData.effectiveDate = toYYYYmmddFullDate(effectiveDate)
							itemData.expiryDate = toYYYYmmddFullDate(expiryDate)
						}
						if (updatedAt !== '' && !updatedAt.includes('-')) {
							itemData.updatedAt = toYYYYmmddFullDate(updatedAt)
						}
					})
					this.tableData = response.data.data
				})
				.catch(() => {})
				.finally(() => {
					this.tableLoading = false
				})
		},
		getProcess(page) {
			this.tableLoading = true
			proxyProcessMy(
				Object.assign({
					page: page.currentPage,
					pageSize: page.pageSize,
					proxyFlag: 'apply_list',
					//排序
					sortType: 2,
					data: {
						applyTypes: ['201', '402', '403', '413', '412'],
					},
				}),
			)
				.then((response) => {
					this.page.total = response.data.data.total
					this.tableOption = policyProcessOption
					this.tableData = []
					if (this.page.total > 0) {
						this.tableData = response.data.data.records
					}
				})
				.catch(() => {})
				.finally(() => {
					this.tableLoading = false
				})
		},
		rowDel: function (row, index) {
			this.$confirm('是否确认删除ID为' + row.id, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(function () {
					return delObj(row.id)
				})
				.then((data) => {
					this.$message.success('删除成功')
					this.getList(this.page)
				})
		},
		handleUpdate: function (row, index, done, loading) {
			putObj(row)
				.then((data) => {
					this.$message.success('修改成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		handleSave: function (row, done, loading) {
			addObj(row)
				.then((data) => {
					this.$message.success('添加成功')
					done()
					this.getList(this.page)
				})
				.catch(() => {
					loading()
				})
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		searchReset() {
			let status = this.searchForm.status
			this.searchForm = {}
			this.searchForm.status = status
			this.toList()
		},
		searchChange(form, done) {
			// Added by Li Yong on 2021/09/13
			form.status = this.searchForm.status
			//
			this.searchForm = form
			let dateRange = form.dateRange || []
			if (dateRange && dateRange.length > 1) {
				//包含投保时间
				this.searchForm.beginInsureTime = dateRange[0]
				this.searchForm.endInsureTime = dateRange[1]
			}
			//createdTime 和上面一直
			// 查询条件增加了beginInsureTime、endInsureTime，返回的字段是createdTime

			// Added by Li Yong on 2021/09/07
			// myList接口被保企业使用unitInfo，但服务端实际会用unitInfo同时在投保企业和被保企业中查询
			if (form.insured !== undefined) {
				this.searchForm.unitInfo = form.insured
			}
			//
			this.page.currentPage = 1
			this.getList(this.page, form)
			done()
		},
		refreshChange() {
			switch (this.searchForm.status) {
				case '-2':
					this.getProcess(this.page)
					break
				case '999':
					this.getStagingList(this.page)
					break
				default:
					this.getList(this.page)
					break
			}
		},
		statusChange() {
			this.page.currentPage = 1
			let {status} = this.searchForm
			switch (status) {
				case '-2':
					this.searchForm = {}
					this.searchForm.status = '-2'
					this.getProcess(this.page)
					break
				case '999':
					this.searchForm = {}
					this.searchForm.status = '999'
					this.getStagingList(this.page)
					break
				default:
					this.getList(this.page)
					break
			}
			//处理埋点
			const button_name = this.statusButtons.find((item) => item.label == status)?.text || ''
			if (button_name) {
				sensorsUtils.trackEvent('policy_search_function_tab_click', {
					button_name,
				})
			}
		},
		//402、修改被保人   403、新增共同被保人
		async onAddInsured(rowData = {}, type) {
			this.isShowLoading = true
			//处理数据
			this.rowSelected = rowData
			this.currentType = type
			//先获取页面跳转
			let reqData = {
				proxyFlag: 'check_process',
				data: {
					orderId: rowData.orderId,
				},
			}
			proxyProcess(reqData)
				.then((response) => {
					let {
						data: {hasClaim = false, tips = ''},
					} = response.data
					if (hasClaim && !this.validatenull(tips)) {
						this.$alert(tips, '提示', {
							confirmButtonText: '我已知晓',
						}).then(() => {
							//投保提醒接口，获取跳转路径
							this.onShowHint()
						})
					} else {
						this.onShowHint()
					}
				})
				.catch((err) => {})
				.finally(() => {
					this.isShowLoading = false
				})

			//加埋点
			this.onAddTrackEvent(`${type == 402 ? '修改被保人' : '新增共同被保人'}`, rowData.orderId)
		},
		//跳转至批量修改被保险人
		onToMoreInsured(type = '') {
			//跳转
			toInsureCenter({orderId: '312265', fromType: type, flag: 2})

			//加埋点
			this.onAddTrackEvent(`${type == 'editMoreInsured' ? '批量修改被保险人' : '批量增加被保险人'}`, '')
		},
		onPayOffLineSuccess() {
			//对公支付成功
			this.refreshChange()
		},
		//对公支付
		onToOfflinePay(offPayData) {
			this.$refs.refPayDialog.dealData(offPayData)
		},
		//获取支付按钮数据
		getOrderData({paySource, certFile, productType, insureType, orderId, productId, totalMoney}) {
			return {
				paySource,
				certFile,
				productId,
				sourceProductId: productType,
				insureType,
				orderId,
				isIndex: true,
				totalPrice: totalMoney,
			}
		},
		//取消
		handleCancel({applyType, id, unitName}) {
			let proxyFlag = ''
			let textTemp = '新增公共保险人'
			let data = {}
			if (applyType == 403 || applyType == 402 || applyType == 412 || applyType == 413) {
				//共同保险人
				proxyFlag = 'cancel_process'
				data.id = id
				if (applyType == 402) {
					textTemp = '修改被保险人'
				} else if (applyType == 412) {
					textTemp = '批量修改被保险人'
				} else if (applyType == 413) {
					textTemp = '批量增加被保险人'
				}
			}
			if (proxyFlag === '') {
				this.$message.error('数据有误!')
				return
			}
			this.isShowLoading = true
			this.$confirm(`是否确认取消【${unitName}】${textTemp}？`, '警告', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					return proxyProcess({proxyFlag, data})
				})
				.then(() => {
					//刷新
					this.refreshChange()
				})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//处理投保前的弹窗
		onDealDialog() {
			let {insureType, sourceProductId = '', productId = '', orderId = ''} = this.rowSelected
			console.log(insureType, sourceProductId, productId, '-------1')
			//如果是计划书，则直接走啦
			if (this.act === 'plan') {
				if (productId === '') {
					this.$alert('该保单不支持续保计划书，可尝试通过产品库进入计划书！', '提示').then(() => {})
					return
				}
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/plan/planInsure`,
					}),
					query: {
						productId: sourceProductId,
						productIdCenter: productId,
						insureType,
						orderId,
					},
				})
				return
			}
			//只走产品中心！旧的禁止投保
			if (!productId) {
				this.$alert(`错误代码：P100-${sourceProductId}-002：保单数据异常，请联系管理员更新数据！`, '提示', {}).then(
					() => {},
				)
				return
			}
			this.currentType = EnumInsureUrlType.insure
			//产品中心
			this.onShowHint()
		},
		/**
		 * changeScene 402、修改被保人   403、新增共同被保人
		 */
		async onShowHint() {
			//先到组件框架里找，如果没有则请求
			let {sourceProductId = '', productType = '', productId = '', orderId = ''} = this.rowSelected || {}
			sourceProductId = sourceProductId || productType
			this.rowSelected.sourceProductId = sourceProductId
			//处理数据
			this.isShowLoading = true
			//请求参数
			let tempReq = {productId, sourceProductId, orderId}
			//新增共保人
			if (this.currentType === EnumInsureUrlType.addInsured) {
				tempReq.operate = 2
				tempReq.changeScene = '403'
			} else if (this.currentType === EnumInsureUrlType.editSingleInsured) {
				tempReq.operate = 2
				tempReq.changeScene = '402'
			}
			await this.$refs.refInsureNotices.onGetHintInfoData(
				tempReq,
				this.currentType === EnumInsureUrlType.insure
					? ({productIdNew, sourceProductIdNew}) => {
							//更新当前ID数据！
							if (productIdNew && productId !== productIdNew) {
								this.rowSelected.sourceProductId = sourceProductIdNew
								this.rowSelected.productId = productIdNew
							}
					  }
					: null,
			)
			this.isShowLoading = false
		},
		//投保提醒回调
		onAgreeInsure() {
			//当前select
			let {
				sourceProductId,
				orderId = '',
				id,
				insureType,
				productId = '',
				payId = '',
				productName = '',
			} = this.rowSelected
			if (this.currentType === EnumInsureUrlType.insure) {
				let pageId = getPageId()
				if (this.rrlogEventId) {
					setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
				}
				//跳转投保页
				toInsureCenter({
					act: this.act,
					pageId: pageId,
					stagingId: id,
					orderId: orderId === '' ? '' : orderId + '',
					productId: productId + '',
					insureType: `${insureType}`,
					payId,
					sourceProductId,
				})
			} else {
				toInsureCenter({orderId, fromType: this.currentType, productName})
			}
		},
		onGetRedPacketCode(itemData) {
			let {orderId, redpackStatus = ''} = itemData
			if (redpackStatus === 'RECEIVED') {
				this.$message.error('红包已领取！')
				return
			}
			this.currentOrderId = orderId
			this.isShowLoading = true
			getRedpackDetailSync(orderId, redpackStatus)
				.then((tempCodeUrl) => {
					this.qrCodeUrl = tempCodeUrl
					this.isShowQrCode = true
					//如果item的数据为WAIT_CONFIRM
					if (redpackStatus === 'WAIT_CONFIRM') {
						itemData.redpackStatus = 'WAIT_RECEIVE'
					}
				})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//刷新小程序码
		onRefreshCode() {
			this.isShowLoading = true
			getRedpackDetailSync(this.currentOrderId)
				.then((tempCodeUrl) => {
					this.qrCodeUrl = tempCodeUrl
					this.$message.success('小程序码已刷新！')
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//下载
		onDownloadPayFile({orderId = ''}) {
			this.isShowLoading = true
			downloadPolicyFeeDetail(orderId)
				.then((res) => {
					let {code = -1, data = ''} = res.data
					if (code !== 200 || !data) {
						this.$message.error('下载失败！')
						return
					}
					this.$message.success('下载成功！')
					openPdfUrl(data)
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})

			//加埋点
			sensorsUtils.trackEvent('policy_search_function_operate_click', {
				button_name: '下载缴费通知书',
				order_id: orderId,
			})
		},
		//取消保单，人保
		onCancelPolicy({insured, orderId = ''}) {
			//加二次确认，是否取消保单
			this.$confirm(`是否取消【${insured}】的订单？`, '提示', {
				confirmButtonText: '确认取消',
				cancelButtonText: '不取消',
			}).then(() => {
				this.isShowLoading = true
				onCancelPolicy(orderId)
					.then((res) => {
						this.$alert('订单已取消成功！如果需要重新提交当前的订单，请点击"已取消"菜单按钮进行操作！')
						//刷新
						this.refreshChange()
					})
					.catch((error) => {
						console.error('onCancelPolicy-----', error)
					})
					.finally(() => {
						this.isShowLoading = false
					})
			})

			//加埋点
			this.onAddTrackEvent('取消保单', orderId)
		},

		/**
		 * 加埋点
		 * @param button_name 按钮名称
		 */
		onAddTrackEvent(button_name, order_id) {
			//加埋点
			sensorsUtils.trackEvent('policy_search_function_operate_click', {
				button_name,
				order_id,
			})
		},
	},
	beforeRouteEnter(to, from, next) {
		let {path = ''} = from
		next((vm) => {
			//申请退款页面返回时，刷新列表
			if (path && path.includes('/surrender')) {
				vm.refreshChange()
			}
		})
	},
}
</script>
<style lang="scss" scoped>
::v-deep .xubao_huo .el-radio-button__inner {
	padding: 3px 12px !important;
}

.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
}

.el-dropdown {
	font-weight: bold;
	font-size: 12px;
}

.el-icon-arrow-down {
	//font-size: 0.98em;
}

.icon-test {
	width: 23px;
	height: 23px;
}
</style>
